import React from 'react';
import { Link } from 'react-router-dom';

import { libelle } from '../../lib/libelles';
import { formatHeure, formatNombre } from '../../lib/formats';
import { History } from 'lucide-react';

import { Panneau, PanneauVide } from './Panneau';

/**
 * « Activité récente » de l'accueil d'une station : les derniers événements,
 * une ligne chacun (« 09:12  Vente à crédit · Transports Keita   1 000 L · 940 000 FCFA »).
 * Un clic ouvre l'écran concerné (`lien` du serveur, sinon selon le type).
 * Sans « montants visibles », seuls les litres restent.
 */
const LIEN_PAR_TYPE = {
  reception: () => '/stations/cuves',
  dip: () => '/stations/cuves',
  tank_variance: () => '/stations/cuves',
  price_change: () => '/stations/prix',
};

export const lienDeLigne = (ligne, stationId) =>
  ligne.link || (LIEN_PAR_TYPE[ligne.kind] ? LIEN_PAR_TYPE[ligne.kind]() : `/stations/${stationId}/poste`);

export const valeurDeLigne = (ligne, montantsVisibles) => {
  const parties = [];
  const litres = ligne.liters === null || ligne.liters === undefined ? null : Number(ligne.liters);
  if (litres !== null && Number.isFinite(litres)) {
    parties.push(`${ligne.kind === 'reception' ? '+' : ''}${formatNombre(litres, 0)} L`);
  }
  const montant = ligne.amount === null || ligne.amount === undefined ? null : Number(ligne.amount);
  if (montantsVisibles && montant !== null && Number.isFinite(montant)) {
    parties.push(`${formatNombre(montant, 0)} FCFA`);
  }
  return parties.join(' · ');
};

export const ActiviteRecente = ({ stationId, lignes = [], montantsVisibles = false, jour, onOuvrir, className }) => (
  <Panneau
    className={className}
    titre="Activité récente"
    droite={
      <Link
        className="text-xs font-medium text-primary underline-offset-4 hover:underline"
        to={`/stations/rapports?station=${stationId}${jour ? `&date=${jour}` : ''}`}
      >
        Tout voir ›
      </Link>
    }
  >
    {lignes.length === 0 ? (
      <PanneauVide icone={History} texte="Aucune activité récente" />
    ) : (
      <ul className="m-0 list-none p-0 text-sm">
        {lignes.map((ligne) => {
          const valeur = valeurDeLigne(ligne, montantsVisibles);
          const texte = [ligne.label || libelle('station_activite', ligne.kind), ligne.detail].filter(Boolean).join(' · ');
          return (
            <li key={ligne.id} className="border-b border-border/60 last:border-0">
              <button
                type="button"
                onClick={() => onOuvrir(lienDeLigne(ligne, stationId))}
                className="grid w-full grid-cols-[3rem_minmax(0,1fr)_auto] items-baseline gap-3 px-3 py-2 text-left hover:bg-muted/40 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
              >
                <span className="tabular-nums text-muted-foreground">{formatHeure(ligne.at)}</span>
                <span className="min-w-0 break-words">{texte}</span>
                <span className="whitespace-nowrap text-right tabular-nums">{valeur}</span>
              </button>
            </li>
          );
        })}
      </ul>
    )}
  </Panneau>
);

export default ActiviteRecente;
